const pageNameKey = "userStatusWithSwitch";

export const userStatusWithSwitchEn = {
  [pageNameKey]: {
    label: "Status",
    userStatusCannotBeChangedText:
      "The user cannot be currently activated or deactivated.",
  },
};

export const userStatusWithSwitchPtBr = {
  [pageNameKey]: {
    label: "Status",
    userStatusCannotBeChangedText:
      "No momento, não é possível ativar ou desativar o usuário.",
  },
};

export const userStatusWithSwitchDe = {
  [pageNameKey]: {
    label: "Status",
    userStatusCannotBeChangedText:
      "Der Benutzer kann derzeit nicht aktiviert oder deaktiviert werden.",
  },
};

export const userStatusWithSwitchZhHans = {
  [pageNameKey]: {
    label: "状态",
    userStatusCannotBeChangedText: "用户当前无法激活或停用。",
  },
};

export const userStatusWithSwitchIt = {
  [pageNameKey]: {
    label: "Stato",
    userStatusCannotBeChangedText:
      "L'utente non può attualmente essere attivato o disattivato.",
  },
};

export const userStatusWithSwitchEs = {
  [pageNameKey]: {
    label: "Estado",
    userStatusCannotBeChangedText:
      "Actualmente no se puede activar ni desactivar al usuario.",
  },
};

export const userStatusWithSwitchNl = {
  [pageNameKey]: {
    label: "Status",
    userStatusCannotBeChangedText:
      "De gebruiker kan momenteel niet worden geactiveerd of gedeactiveerd.",
  },
};

export const userStatusWithSwitchTr = {
  [pageNameKey]: {
    label: "Durum",
    userStatusCannotBeChangedText:
      "Kullanıcı şu anda etkinleştirilemez veya devre dışı bırakılamaz.",
  },
};
